export {
  mapObjectEntries,
  nestedArrToString,
  cloneDeep,
  getRandomNumber,
  getRandomString,
  getDeviceId,
  resetDeviceId,
  sleep,
  isEmpty,
  htmlToText,
  toRawDeep,
  checkWebview,
  convertArrayToKeyedObject,
  trimNestedArray,
  trimObject,
  genDefaultValueProxy,
  genObjectWithDefaultKey,
  safeJsonParse,
  parseQueryString,
  getUserCountryCode,
  hashString,
} from '@myfunnow/web-core'
export { removeEmojis, getSegmentsList } from '@myfunnow/web-core/string'

export const throwNotFoundError = (isClientSide = false) => {
  const msg = 'Page Not Found'

  if (isClientSide) {
    showError({ statusCode: 404, message: msg })
  } else {
    throw createError({ statusCode: 404, statusMessage: msg })
  }
}

export function findKeywordIndices(text: string, keyword: string) {
  const result: number[] = []

  if (!text || !keyword) {
    return []
  }

  const lowercaseText = text.toLowerCase()
  const lowercaseKeyword = keyword.toLowerCase()
  let matchedIndex = -1

  for (let i = 0; i < lowercaseText.length; i++) {
    matchedIndex = lowercaseText.indexOf(lowercaseKeyword[i], matchedIndex + 1)

    if (matchedIndex === -1) {
      break
    }

    result.push(matchedIndex)
  }

  return result
}

export const pathJoin = (parts: string[]) =>
  parts
    .join('/')
    .replace(/^\/{2,}/, '/')
    .replace(/([^:])\/{2,}/g, '$1/')
